// extracted by mini-css-extract-plugin
export default {"userAvatarRound":"UserAvatar_userAvatarRound__pWha3"};